/* istanbul ignore file */
import 'core-js';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import React from 'react';
import App from './App';

if (window.location.port === process.env.REACT_APP_PORT || window.location.host.includes('cloudfront.net')) {
  const appDom = document.getElementById('root');

  ReactDOM.render(
    <Router>
      <App />
    </Router>,
    appDom,
  );
}
